import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@workith/ui";
import { MoreVertical } from "lucide-react";
import type { ReactNode } from "react";

interface RowActionsMenuProps {
  children: ReactNode;
}

// 카드 행 우측의 ⋮ 액션 메뉴 셸. 카드 클릭으로의 이벤트 전파 차단은 여기서만 담당한다.
export function RowActionsMenu({ children }: RowActionsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="min-w-[180px]"
        align="end"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
